import React from "react";

/**
 * Fallback – Pantalla de inicio cuando se navega a "/".
 * Muestra el logo de Kurios y un mensaje indicando que el usuario
 * debe acceder mediante el enlace personalizado enviado por correo.
 */
export default function Fallback() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "1rem",
        backgroundColor: "#f7f9fc",
      }}
    >
      <img
        src="https://kuriosedu.s3.us-east-2.amazonaws.com/media/logos/LogoKuriospRUEBA.png"
        alt="Logo Kurios Education"
        style={{ maxWidth: "220px", width: "100%", marginBottom: "2rem" }}
      />

      <h1 style={{ fontSize: "1.5rem", color: "#330072", maxWidth: "28ch" }}>
        Para visualizar tu reporte, ingresa mediante el enlace único que el equipo Kurios
        te envió vía correo electrónico.
      </h1>
    </div>
  );
}
